import * as S from './BankList.styled';
import { Avatar, Tmd14 } from 'oui';

export interface IBankList {
  partners: any;
}

const BankList = ({ partners }: IBankList) => {
  return (
    <S.BankList>
      {partners.map((comp: any) => (
        <S.BankListItem key={comp.compSeq}>
          <Avatar
            source={comp.logoUrl}
            alt={`${comp.compNm}-logo`}
            size={'sm'}
          />
          <S.SubTitle>
            <Tmd14 text={comp.compNm} color={'#363636'} />
          </S.SubTitle>
        </S.BankListItem>
      ))}
    </S.BankList>
  );
};

export default BankList;
